import { createChatBotMessage, createCustomMessage } from 'react-chatbot-kit';
import DogPicture from './DogPicture';
import BotChatMessage from './BotChatMessage';
import CustomMessage from './CustomMessage';
import CustomerDocPicture from './CustomerDocPicture';
import LoadingMessage from './LoadingMessage';

const config = {
  // initialMessages: [createChatBotMessage(`Hello world`)],
  initialMessages: [],
  customStyles: {
    botMessageBox: {
      backgroundColor: '#f5f7fa',
    },
    chatButton: {
      backgroundColor: '#5ccc9d',
      borderRadius: '20px',
      padding: '6px 16px',
    },
  },
  widgets: [
    {
      widgetName: 'dogPicture',
      widgetFunc: (props) => <DogPicture {...props} />,
    },
    {
      widgetName: 'customerDocPicture',
      widgetFunc: (props) => <CustomerDocPicture {...props} />,
    }
  ],
  customComponents: {
    // botChatMessage: (props) => <BotChatMessage {...props} />,
    botLoading: (props) => <LoadingMessage {...props} />,
  },
  customMessages: {
    custom: (props) => <CustomMessage {...props} />,
  }
};

export default config;
